import React from 'react';
import Container from "./Container";
export function AppBanner(props) {
  return React.createElement(Container, props);
}
export default AppBanner;